import { Box, Typography } from "@material-ui/core";

import MaskAndValid from "utils/maskAndValid";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

export default function StoreSelect({
  requiresSelection,
  singleStoreName,
  options,
  value,
  onChange,
  loading,
  disabled,
}) {
  if (!requiresSelection) {
    if (!singleStoreName) return null;
    return (
      <Box className="custom-select-wrapper" style={{ minWidth: 200, flex: 1 }}>
        <Box
          className="custom-select-btn"
          style={{ cursor: "default", pointerEvents: "none" }}
        >
          <Typography noWrap style={{ fontSize: 14, flex: 1 }}>
            {singleStoreName}
          </Typography>
        </Box>
      </Box>
    );
  }

  function formatCpfCnpjExibicao(raw) {
    if (raw == null || raw === "") return "";
    const digits = String(raw).replace(/\D/g, "");
    if (digits.length === 11) return MaskAndValid.maskCPF(digits);
    if (digits.length === 14) return MaskAndValid.maskCNPJ(digits);
    if (digits.length > 0) return digits;
    return String(raw).trim();
  }

  const autoCompleteOptions = options.map((l) => ({
    id: l.idPessoaLoja,
    label: l.cnpjLoja
      ? `${l.nomeLoja} | ${formatCpfCnpjExibicao(l.cnpjLoja)}`
      : l.nomeLoja,
  }));

  const selected = options.find((l) => l.idPessoaLoja === value);
  const selectedOption = selected
    ? {
        id: selected.idPessoaLoja,
        label: selected.cnpjLoja
          ? `${selected.nomeLoja} | ${formatCpfCnpjExibicao(selected.cnpjLoja)}`
          : selected.nomeLoja,
      }
    : null;

  return (
    <Box style={{ minWidth: 260, flex: 1 }}>
      <AutoCompleteField
        options={autoCompleteOptions}
        label="Selecione a loja"
        required
        optionLabelKey="label"
        optionIdKey="id"
        onChange={(option) => onChange(option?.id ?? null)}
        value={selectedOption}
        disabled={disabled}
        loading={loading}
        ignoreCnpjPunctuationInSearch
      />
    </Box>
  );
}
